module.exports = "<app-img-header imgUrl=\"/assets/images/img-headers/apartments.jpg\"></app-img-header>\r\n\r\n<div class=\"apartment-two-container\">\r\n  <div class=\"container\">\r\n\r\n    <div class=\"separator\"></div>\r\n    \r\n    <gallery \r\n      galleryName = \"galleryApartment2\">\r\n    </gallery>\r\n\r\n    <div class=\"separator\"></div>\r\n\r\n    <a routerLink = \"/apartments\">\r\n        <p class=\"title\" translate [innerHTML]=\"'APARTMENTS.BACK' | translate\">\r\n        </p>\r\n    </a>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apartment-two/apartment-two.component.html
// module id = 778
// module chunks = 1